module.exports = __webpack_public_path__ + "static/media/how-it-works-3.0465d269.png";